import { Injectable, signal } from '@angular/core';

/** Holds the "an uncaught error happened" state that the root shell renders a fallback for. */
@Injectable({ providedIn: 'root' })
export class ErrorBoundaryStore {
  readonly hasError = signal(false);
  readonly error = signal<unknown>(null);

  report(error: unknown): void {
    this.error.set(error);
    this.hasError.set(true);
  }

  reset(): void {
    this.hasError.set(false);
    this.error.set(null);
  }
}
